/*
saikrishna 10/06/2022 3075154998  Removed unecesarry console.log statements
dilip 10/11/2022 3075154998  Data Manager Matching logic changes
Suresh Peddavoora 10/26/2022 3075154998  Changed Text Field Variant from outlined to standard
Akhila  10/28/2022 3075154998 data manager ux changes
Suresh Peddavoora 10/31/2022 3075154998  Added Styles for Table header card
Suresh Peddavoora 10/31/2022 3075154998  Added spacing for feilds and removed the boostrap classes.
Lalitha           11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {Button, Grid, TextField, Typography, FormHelperText} from '@material-ui/core';
import DialogBox from '../../../../../components/DialogBox';
import ConditionForm from './Condition/AddCondition';
import ConditionTable from './Condition/ConditionTable';
import ActionForm from './Action/ActionForm';
import ActionTable from './Action/ActionTable';
import FiltersSystemNotes from './FiltersSystemNotes';
import {
  saveFilter,
  fetchFilter,
  ResetStatus as resetStatus,
  ResetMessage as resetMessage,
  getDropDownData,
} from '../../../../../redux/reducers/DataManagerFilter';
import {resettingFieldData} from '../../../../../redux/reducers/BRE/AddRecordFormat';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

import {RECORD_TYPE} from '../../../../../constants/Lookup';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {getObject} from '../../../../../util/GetDropdownObject';
import AddIcon from '@material-ui/icons/Add';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
// import OverrideRule from "../../../../../components/OverrideRule";
import {makeStyles} from '@material-ui/core/styles';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px 0',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));
const AddFilterForm = ({
  setTabValue,
  filterCode,
  setFilterCode,
  setFilterCodeName,
  filterCodeName,
  isCopyRowData,
  setUsageState,
}) => {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    filterDataStatus,
    successMsg,
    errorMsg,
    isLoading,
    filterData,
  } = useSelector(({dataManagerFilter}) => dataManagerFilter);
  const {dropDownData} = useSelector(({filter}) => filter);
  const initialValues = {
    filterName: isCopyRowData ?
      '' :
      filterData && filterData.filterCode ?
        filterData.filterCode :
        '',
    description: filterData && filterData.description ? filterData.description : '',
    recordType:
      filterData && filterData?.recordType ?
        getObject(filterData.recordType, RECORD_TYPE, dropDownData) :
        '',
    conditionArgument:
      filterData && filterData.conditionArgument ? filterData.conditionArgument : '',
  };
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    filterCode && dispatch(fetchFilter(filterCode));
  }, [filterCode]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [actionOpen, setActionOpen] = useState(false);
  const [actionData, setActionData] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [actionRowData, setActionRowData] = useState('');
  const [actionCode, setActionCode] = useState('');
  const [deleteAction, setDeleteAction] = useState([]);
  const [expanded, setExpanded] = useState();
  const [ruleGroupSNo, setRuleGroupSNo] = useState(1);
  const [conditionData, setConditionData] = useState([]);
  const [isConditionEditMode, setIsConditionEditMode] = useState(false);
  const [conditionRowData, setConditionRowData] = useState('');
  const [conditionCode, setConditionCode] = useState('');
  const [deleteCondition, setDeleteCondition] = useState([]);
  const [reset, setReset] = useState(false);


  const schema = Yup.object().shape({
    filterName: Yup.string()
      .required('Filter code is required')
      .matches(/^[a-zA-Z0-9]+$/, 'White space and special character are not allowed'),
    description: Yup.string().required('Description is required'),
    conditionArgument:
      conditionData?.length > 0 ? Yup.string().required('Condition argument is required') : '',
  });
  useEffect(() => {
    if (filterDataStatus === 200) {
      setTimeout(() => {
        setTabValue(0);
        dispatch(resetStatus());
        dispatch(resetMessage());
      }, 2000);
    }
  }, [filterDataStatus]);

  // useEffect(() => {
  //   if (addFiltersStatus === 200 && userMetrix === "Yes") {
  //     setDialogState(true);
  //     setTimeout(() => {
  //       dispatch(ResetFiltersRule());
  //     }, 2500);
  //   }
  // }, [userMetrix, addFiltersStatus]);

  const handleConditionClose = () => {
    setFilterOpen(false);
    setIsConditionEditMode(false);
    setRuleGroupSNo(conditionData?.length);
  };
  const handleActionCLose = () => {
    setActionOpen(false);
    setIsEditMode(false);
    dispatch(resettingFieldData());
  };

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  useEffect(() => {
    if (Object.keys(filterData).length > 0) {
      const data = [...filterData?.filterConditions];
      const newData = data.map((i) => {
        const conditionList = {
          ...i,
          conditionId: i?.conditionId ? i?.conditionId : 0,
          conditionOperator: i?.conditionOperator ? i.conditionOperator : '',
          srcField: i?.srcField ? i.srcField : '',
          fieldOne: i?.fieldOne ? i.fieldOne : '',
          fieldFormat: i?.fieldFormat ? i.fieldFormat : '',
          sequenceNo: i?.sequenceNo ? Number(i?.sequenceNo) : '',
        };

        return conditionList;
      });
      setConditionData(newData);
    }
    if (Object.keys(filterData).length > 0) {
      const data = [...filterData?.filterActions];
      const newActionData = data.map((i) => {
        return {
          ...i,
          description: i?.description ? i.description : '',
          conditionOperator: i?.conditionOperator ? i.conditionOperator : '',
          fieldFormat: i?.fieldFormat ? i.fieldFormat : '',
          actionId: i?.actionId ? i?.actionId : 0,
          name: i?.fieldCode ? i.fieldCode : '',
          returnValueType: i?.returnType ? i.returnType : '',
          sourceField: i?.sourceField ? i.sourceField : '',
          toField: i?.toField ? i.toField : '',
          type: i?.type ? i.type : '',
          sequenceNo: i?.sequenceNo ? Number(i?.sequenceNo) : '',

          disposition: i?.disposition ? i.disposition : '',
        };
      });
      setActionData(newActionData);
    }
  }, [filterData, reset]);

  const handleSubmit = (values) => {
    const conditions =
      conditionData?.length > 0 ?
        conditionData.map((data) => {
          const conditionAction = {
            conditionOperator: data?.conditionOperator ? data?.conditionOperator : '',
            dataOrFieldTwo: '',
            fieldFormat: data?.fieldFormat ? data.fieldFormat : '',
            fieldOne: data?.fieldOne ? data.fieldOne : '',
            filterConditionId: 0,
            sequenceNumber: 0,
          };
          return conditionAction;
        }) :
        [];
    const actions =
      actionData.length > 0 ?
        actionData.map((data) => {
          const action = {
            description: data?.description ? data.description : '',
            actionParamOne: data?.actionParamOne ? data.actionParamOne : '',
            disposition: data?.disposition ? data.disposition : '',
            format: data?.format ? data.format : '',
            actionId: data?.actionId ? data.actionId : 0,
            name: data?.fieldCode ? data.fieldCode : '',
            returnValueType: data?.returnType ? data.returnType : '',
            sourceField: data?.sourceField ? data.sourceField : '',
            fieldOne: data?.toField ? data.toField : '',
            filterAction: data?.filterAction ? data.filterAction : '',
            sequenceNo: data?.seqNo ? data.seqNo : '',
          };
          return action;
        }) :
        [];

    // const postData = {
    //   description: values?.description ? values?.description : "",
    //   id: isCopyRowData ? 0 : filterData?.id ? filterData?.id : 0,
    //   name: values?.filterName ? values.filterName.toUpperCase() : "",
    //   type: values?.recordType ? values.recordType?.valueCode : "",
    //   filterDeleteIds: deletedFieldsAction,
    //   conditionDeletedIds: deletedFieldsCondition,
    //   conditionList: conditions?.length > 0 ? conditions : [],
    //   actionList: actions?.length > 0 ? actions : [],
    //   conditionArgument: values?.conditionArgument ? values.conditionArgument : "",
    //   override: "No",
    // };
    const postData = {
      actionRequest: actions,
      conditionRequest: conditions,
      description: values?.description ? values?.description : '',
      filterActionDeletedIds: [0],
      filterCode: values?.filterName ? values.filterName.toUpperCase() : '',
      filterConditionDeletedIds: [0],
      filterDeleteIds: [0],
      filterId: filterData?.id ? filterData?.id : 0,
      recordType: values?.recordType ? values.recordType?.valueCode : '',
      conditionArgument: values.conditionArgument ? values.conditionArgument :'',
    };
    // setOverRiding(postData);
    dispatch(saveFilter(postData));
  };
  return (
    <div>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          disabled={isLoading || successMsg}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            setTabValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
                    Search Filter
        </Button>
      </div>
      <div>
        <Formik
          onSubmit={(values, {validate}) => {
            handleSubmit(values);
            validate(values);
          }}
          initialValues={initialValues}
          validationSchema={schema}
          validateOnChange={true}
          validateOnBlur={false}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
              resetForm,
            } = props;
            return (
              <div className={`mb-0`}>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div className="global-field-textfields">
                    <Grid container spacing={2}>
                      <Grid item xs={4} xl={3} md={3} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter Filter Code"
                          label="Filter Code"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="filterName"
                          value={values?.filterName?.toUpperCase()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.filterName}
                          error={Boolean(touched.filterName && errors.filterName)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.filterName && errors.filterName}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={4} xl={3} md={3} sm={6} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="recordType"
                          id="recordType"
                          size="small"
                          value={values.recordType}
                          options={getOptions(RECORD_TYPE, dropDownData)}
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option.valueCode && option.value ?
                              option.valueCode + ' - ' + option.value :
                              option.value === null ?
                                option.valueCode :
                                option.value ?
                                  option.value :
                                  '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('recordType', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                error={touched.recordType && errors.recordType}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Record Type"
                                placeholder="Select Record Type"
                              />
                            </div>
                          )}
                        />
                      </Grid>

                      <Grid item xs={4} xl={6} md={6} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Description`}
                          label="Description"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.description}
                          error={Boolean(touched.description && errors.description)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.description && errors.description}
                        </FormHelperText>
                      </Grid>
                    </Grid>
                    <Grid>
                      <div>
                        <Grid item className={`border-rounded mb-4`}>
                          <div className="table-header table-card-header d-flex justify-content-between">
                            <Typography variant="h3">Conditions: </Typography>
                            <Button
                              variant="outlined"
                              className={`search-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                setFilterOpen(true);
                                const reqNo =
                                conditionData?.length > 0 &&
                                conditionData[conditionData?.length - 1]?.code ?
                                  Number(conditionData[conditionData?.length - 1].code.slice(1)) +
                                    1 :
                                  conditionData?.length + 1;
                                setRuleGroupSNo(reqNo);
                              }}
                            >
                              <AddIcon />
                            Add Condition
                            </Button>
                          </div>
                          <ConditionTable
                            conditionData={conditionData}
                            setConditionData={setConditionData}
                            setIsConditionEditMode={setIsConditionEditMode}
                            setConditionRowData={setConditionRowData}
                            setConditionCode={setConditionCode}
                            setDeleteCondition={setDeleteCondition}
                            deleteCondition={deleteCondition}
                            ruleGroupSNo={ruleGroupSNo}
                          />
                        </Grid>
                        <Grid item xs={4} xl={6} md={6} sm={6} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Condition Argument`}
                            label="Condition Argument"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="conditionArgument"
                            value={values.conditionArgument}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            required={conditionData?.length > 0}
                            touched={touched.conditionArgument}
                            error={Boolean(touched.conditionArgument && errors.conditionArgument)}
                          />
                          {conditionData?.length > 0 ? (
                            <FormHelperText style={{color: 'red'}}>
                              {errors.conditionArgument}
                            </FormHelperText>
                          ) : null}
                        </Grid>
                        <Grid item className={`border-rounded mb-3`}>
                          <div className="table-header table-card-header d-flex justify-content-between">
                            <Typography variant="h3">Actions: </Typography>
                            <Button
                              variant="outlined"
                              className={`search-btn ${classes.buttonRoot}`}
                              onClick={() => setActionOpen(true)}
                            >
                              <AddIcon />
                            Add Action
                            </Button>
                          </div>
                          <ActionTable
                            actionData={actionData}
                            setActionData={setActionData}
                            setActionRowData={setActionRowData}
                            setIsEditMode={setIsEditMode}
                            setActionCode={setActionCode}
                            setDeleteAction={setDeleteAction}
                            deleteAction={deleteAction}
                          />
                        </Grid>
                      </div>
                    </Grid>
                  </div>
                  <div className="button-spacing-mb">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        if (!filterCode) {
                          setActionData([]);
                          setConditionData([]);
                          resetForm();
                        } else {
                          resetForm();
                          setReset(!reset);
                        }
                      }}
                    >
                    Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                    >
                    Save
                    </Button>
                  </div>
                </form>
                {/* {filterData?.name && !isCopyRowData && ( */}
                <div className={`${classes1.root} mt-3`}>
                  <Accordion
                    className="accordion-styling"
                    expanded={expanded === 'panel1'}
                    onChange={handleAccordionChange('panel1')}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
                      // {...props}
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                    >
                      <Typography className={classes1.heading}>Filters Notes</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes1.detailsCard}>
                      <FiltersSystemNotes
                        setFilterCode={setFilterCode}
                        filterCode={filterCode}
                        setFilterCodeName={setFilterCodeName}
                        filterCodeName={filterCodeName}
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
                {/* )} */}
              </div>
            );
          }}
        </Formik>
        <DialogBox
          open={filterOpen || isConditionEditMode}
          dialogClose={handleConditionClose}
          title={filterOpen ? 'Add Condition' : isConditionEditMode ? 'Edit Condition' : ''}
          maxWidth="md"
        >
          <ConditionForm
            setConditionData={setConditionData}
            conditionData={conditionData}
            setFilterOpen={setFilterOpen}
            handleConditionClose={handleConditionClose}
            conditionRowData={conditionRowData}
            isConditionEditMode={isConditionEditMode}
            setIsConditionEditMode={setIsConditionEditMode}
            conditionCode={conditionCode}
            ruleGroupSNo={ruleGroupSNo}
          />
        </DialogBox>
        <DialogBox
          open={actionOpen || isEditMode}
          dialogClose={handleActionCLose}
          title={actionOpen ? 'Add Action' : isEditMode ? 'Edit Action' : ''}
          maxWidth="lg"
        >
          <ActionForm
            setActionData={setActionData}
            actionData={actionData}
            setActionOpen={setActionOpen}
            handleActionCLose={handleActionCLose}
            actionRowData={actionRowData}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            actionCode={actionCode}
          />
        </DialogBox>

        {/* <OverrideRule
        dialogTitle="Override Filter"
        dialogOpen={dialogState}
        dialogClose={handleDialogState}
        title="This Filter has been used in the following frameworks."
        data={addFiltersData}
        handleOverrideClose={handleDialogState}
        handleOverrideSubmit={() => {
          dispatch(saveFilter({ ...overRiding, override: "Yes" }));
          handleDialogState();
        }}
      /> */}

        {isLoading && <PageLoader />}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </div>
    </div>
  );
};

export default AddFilterForm;
